import { http } from '@shared/api';

export const passwordResetApi = {
  request: (identity: string) =>
    http.post('auth/password/reset/request', { json: { identity, channel: 'EMAIL' } }).json<void>(),

  confirm: (identity: string, code: string, newPassword: string) =>
    http
      .post('auth/password/reset/confirm', {
        json: { identity, channel: 'EMAIL', code, newPassword },
      })
      .json<void>(),

  change: (currentPassword: string, newPassword: string) =>
    http
      .post('account/password/change', { json: { currentPassword, newPassword } })
      .json<void>(),
};
